export enum ScheduledReportReportTypeEnum {
    OutsideProcessContractsSentButNotReceived = 100,
}